/* eslint-disable react-hooks/exhaustive-deps */
import { createContext, useContext, useEffect, useState } from "react";

import { BrowserRouter } from "react-router-dom";
import Event from "../utils/events";
import React from "react";
import SecureLS from "secure-ls";
import api from "../services/api";
import jwt_decode from "jwt-decode";
import serviceUsuario from "@/services/serviceUsuario";
import { clearAllSiteData, handleGetTokenSensedia } from "@/utils/utils";

interface IAuthContext {
    titlePage: string | any;
    setTitlePage: string | any;
    sidebarOpen: boolean;
    setSidebarOpen: React.FC | any;
    isAuth: string | any;
    setIsAuth: string | any;
    handleSaveAuth: any;
    handleGetToken: any;
    handleLogout: any;
    user: any;
    setRoutePermission: React.FC | any;
    routePermission: any[];
    handleGetDataUser: any;
    userLoadError: boolean;
    handleReauth: any;
}

const AuthContext = createContext<IAuthContext>({} as IAuthContext);

export const ContextGlobal = ({ children }: { children: any }) => {
    const [titlePage, setTitlePage] = useState<string | undefined>("");
    const [routePermission, setRoutePermission] = useState<any[]>([]);
    const [sidebarOpen, setSidebarOpen] = useState<boolean>(true);
    const [isAuth, setIsAuth] = useState(false);
    const [user, setUser] = useState<any>();
    const [userLoadError, setUserLoadError] = useState(false);

    var secStorage = new SecureLS({ encodingType: "aes" });
    const tokenStorageName = process.env.REACT_APP_API_SENSEDIA_TOKEN_STORAGE ?? "";

    // effects para emit e on
    useEffect(() => {
        const handleDisplay = (data: any) => {
            handleLogout();
        };

        Event.on("logout", handleDisplay);
        return () => {
            Event.removeEventListener("logout", handleDisplay);
        };
    }, []);

    //funcao para login
    const handleSaveAuth = async (data: any) => {
        const { id_token } = data;

        if (id_token) {
            secStorage.set(tokenStorageName, JSON.stringify(id_token));
            api.defaults.headers.common["id_token"] = id_token;
            setIsAuth(true);
        }

        const decode: any = jwt_decode(id_token);

        const tokenSensedia = await handleGetTokenSensedia();

        const clientIDSensedia = process.env.REACT_APP_API_SENSEDIA_CLIENTID ?? "";

        if (tokenSensedia && clientIDSensedia) {
            api.defaults.headers.common["access_token"] = tokenSensedia;
            api.defaults.headers.common["client_id"] = clientIDSensedia;
        }

        if (decode && tokenSensedia) {
            setUserLoadError(false);
            serviceUsuario
                .getByEmail({ email: decode.email })
                .then((result) => {
                    const { perfil } = result.data;
                    const newObjct = {
                        ...user,
                        nome: decode.name,
                        email: decode.email,
                        perfil: perfil,
                    };
                    setUser(newObjct);
                    secStorage.set("data", newObjct);
                })
                // Sem os dados do usuário a aplicação fica presa na tela "Carregando...".
                // Sinaliza o erro para oferecer o "Entrar novamente".
                .catch(() => {
                    setUserLoadError(true);
                });
        }
        window.history.pushState("", "", "/");
    };

    // "Entrar novamente": limpa completamente o armazenamento do site e reinicia
    // o fluxo de login, redirecionando para o provedor de autenticação.
    const handleReauth = async () => {
        await clearAllSiteData();

        delete api.defaults.headers.common["id_token"];
        delete api.defaults.headers.common["access_token"];
        delete api.defaults.headers.common["client_id"];

        setUserLoadError(false);
        setIsAuth(false);
        setUser({});

        const azureAuth = process.env.REACT_APP_REDIRECT_LOGIN || "";
        if (azureAuth) {
            window.location.href = azureAuth;
        } else {
            window.location.reload();
        }
    };

    const handleGetDataUser = () => {
        const dados = secStorage.get("data");
        return dados;
    };

    const handleGetToken = () => {
        //Token Sensedia
        const tokenSensedia = secStorage.get("access_token");

        if (tokenSensedia) {
            const clientIDSensedia = process.env.REACT_APP_API_SENSEDIA_CLIENTID ?? "";
            api.defaults.headers.common["access_token"] = tokenSensedia;
            api.defaults.headers.common["client_id"] = clientIDSensedia;
        }

        //Token AWS
        const token = secStorage.get(tokenStorageName);

        if (token) {
            api.defaults.headers.common["id_token"] = JSON.parse(token);
            setIsAuth(true);

            return JSON.parse(token);
        }
    };

    const handleLogout = () => {
        secStorage.remove("access_token");
        secStorage.remove(tokenStorageName);
        secStorage.remove("data");
        setIsAuth(false);
        setUser({});
        <BrowserRouter forceRefresh={true} />;
    };

    return (
        <AuthContext.Provider
            value={{
                titlePage,
                setTitlePage,
                sidebarOpen,
                setSidebarOpen,
                isAuth,
                setIsAuth,
                handleSaveAuth,
                handleGetToken,
                handleLogout,
                user,
                setRoutePermission,
                routePermission,
                handleGetDataUser,
                userLoadError,
                handleReauth,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export function useAuth() {
    const context = useContext(AuthContext);
    return context;
}
